module.exports = __webpack_public_path__ + "img/close.2ca9e9a0.svg";